// Update the --ivh CSS variable when the window is resized
// The --ivh represents 1% of the initial viewport height and should not update
// whenever the navbar is shown/hidden, but only on significant changes

let windowWidth = window.innerWidth
let windowHeight = window.innerHeight

window.addEventListener('resizeEnd', () => {
  let newWindowWidth = window.innerWidth
  let newWindowHeight = window.innerHeight

  // Update if width changes or height changes by more than 15%
  let shouldUpdate =
    newWindowWidth !== windowWidth || Math.abs(newWindowHeight - windowHeight) / windowHeight > 0.15

  if (shouldUpdate) {
    document.documentElement.style.setProperty('--ivh', `${newWindowHeight / 100}px`)
  }

  windowWidth = window.innerWidth
  windowHeight = window.innerHeight
})
